import ReactCalendar from "react-calendar";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";

// helpers
export const dateAlreadyClicked = (dates, date) => {
  return dates?.some((d) => dayjs(date).isSame(dayjs(d.date), "day"));
};

const Calendar = ({ className, currentIndex, setDates, dates, onChange, disabled = false }) => {
  const onClickDay = (date) => {
    if (disabled) return; // Prevent date selection when disabled
    onChange();
    let allDates = [];
    Object.keys(dates).forEach((freelancerName, index) => {
      if (index === currentIndex) {
        allDates = dates[freelancerName];
      }
    });

    setDates((prevState) => {
      return {
        ...prevState,
        [currentIndex]: [
          ...prevState[currentIndex],
          {
            date,
            id: uuidv4(),
          },
        ],
      };
    });
  };

  const tileClassName = ({ date }) => {
    let allDates = [];
    Object.keys(dates).forEach((freelancerName, index) => {
      if (index === currentIndex) {
        allDates = dates[freelancerName];
      }
    });
    const classNames = ["calender-tile"];
    // give active days a special class
    if (dateAlreadyClicked(allDates, date))
      return ["calender-tile-active", ...classNames];
    return classNames;
  };

  return (
    <div style={{ position: 'relative' }}>
      <ReactCalendar
        className={`${className} ${disabled ? 'disabled-calendar' : ''}`}
        tileClassName={tileClassName}
        onClickDay={disabled ? undefined : onClickDay}
        style={{
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
          cursor: disabled ? 'not-allowed' : 'pointer'
        }}
      />
      {disabled && (
        <div
          style={{ inset: 0, position: 'absolute', backgroundColor: 'transparent', cursor: 'not-allowed', zIndex: 10, pointerEvents: 'auto' }}
        />
      )}
    </div>
  );
};

export default Calendar;